import { Icon } from '@chakra-ui/react';

export default function CheckFatFilledIcon(props) {
  return (
    <Icon
      data-testid='check-filled-icon'
      width='25'
      height='26'
      viewBox='0 0 25 26'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M23.7605 9.30445L11.2214 21.8435C10.9284 22.1363 10.5312 22.3008 10.117 22.3008C9.70273 22.3008 9.30546 22.1363 9.01246 21.8435L2.01832 14.8123C1.72581 14.5193 1.56152 14.1222 1.56152 13.7083C1.56152 13.2943 1.72581 12.8972 2.01832 12.6043L3.97144 10.6511C4.26428 10.3595 4.66072 10.1958 5.07398 10.1958C5.48725 10.1958 5.88369 10.3595 6.17652 10.6511L10.156 14.5105L19.6052 5.1775C19.8981 4.88559 20.2948 4.72168 20.7083 4.72168C21.1218 4.72168 21.5184 4.88559 21.8113 5.1775L23.7595 7.0857C23.906 7.23089 24.0224 7.40366 24.1018 7.59403C24.1812 7.7844 24.2221 7.98861 24.2222 8.19488C24.2223 8.40114 24.1815 8.60539 24.1023 8.79583C24.0231 8.98627 23.9069 9.15914 23.7605 9.30445Z'
        fill='currentColor'
      />
    </Icon>
  );
}
